import { defineComponent, computed } from 'vue';
import __vue_component__ from '../ui/Skeleton.vue.js';
import __vue_component__$1 from '../ui/Tooltip/Tooltip.vue.js';

var script = defineComponent({
    name: 'SelectComponent',
    components: {
        Skeleton: __vue_component__,
        Tooltip: __vue_component__$1,
    },
    props: {
        /**
         * Pass `true` to disable the input. Pass a string to disable the input
         * and show a tooltip on hover.
         */
        disabled: {
            type: [Boolean, String],
            default: false,
        },
        expanded: Boolean,
        highlight: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: null,
        },
        loading: Boolean,
        placeholder: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'md',
        },
        value: {
            type: String,
            default: null,
        },
        placeholderColor: {
            type: String,
            default: 'default',
        },
    },
    setup(props) {
        const classNames = computed(() => {
            const names = [];
            switch (props.size) {
                case 'sm':
                    names.push('SelectComponent--sm');
                    break;
                case 'md':
                    names.push('SelectComponent--md');
            }
            if (props.placeholderColor) {
                switch (props.placeholderColor) {
                    case 'default': {
                        names.push('SelectComponent--placeholder-default');
                        break;
                    }
                    case 'black': {
                        names.push('SelectComponent--placeholder-black');
                    }
                }
            }
            if (props.disabled)
                names.push('SelectComponent--disabled');
            if (props.highlight)
                names.push('SelectComponent--highlight');
            if (props.expanded)
                names.push('SelectComponent--expanded');
            return names;
        });
        return {
            classNames,
        };
    },
});

export { script as default };
